export const carsData = [
  {
    id: 1,
    year: 2019,
    make: "Honda",
    model: "Civic",
    trim: "LX",
    image: "/images/car-civic-2019.jpeg",
    images: [
      "/images/car-civic-2019.jpeg",
      "/images/car-civic-2019-1.jpeg",
      "/images/car-civic-2019-2.jpeg",
      "/images/car-civic-2019-3.jpeg",
      "/images/car-civic-2019-4.jpeg",
    ],
    price: 17999,
    weeklyPayment: 83,
    bodyStyle: "Sedan",
    transmission: "Automatic",
    stockNumber: "HN19-209",
    isGoodPrice: true,
    km: 160000,
    vin: "2HGFC2F69KH123456",
    engine: "4 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "Black",
    drivetrain: "FWD",
    passengers: 5,
    cylinders: 4,
    condition: "Used",
  },
  {
    id: 2,
    year: 2014,
    make: "BMW",
    model: "528i",
    trim: "Luxury",
    image: "/images/car-bmw-2014.jpeg",
    images: [
      "/images/car-bmw-2014.jpeg",
      "/images/car-bmw-2014-1.jpeg",
      "/images/car-bmw-2014-2.jpeg",
      "/images/car-bmw-2014-3.jpeg",
      "/images/car-bmw-2014-4.jpeg",
      "/images/car-bmw-2014-5.jpeg",
      "/images/car-bmw-2014-6.jpeg",
    ],
    price: 13999,
    weeklyPayment: 265,
    bodyStyle: "Sedan",
    transmission: "8 Speed Automatic",
    stockNumber: "BM22-089",
    isGoodPrice: false,
    km: 98750,
    vin: "WBA5A5C55ED123456",
    engine: "4 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "Black",
    drivetrain: "RWD",
    passengers: 5,
    cylinders: 4,
    condition: "Used",
  },
  {
    id: 3,
    year: 2019,
    make: "KIA",
    model: "Sedona",
    trim: "LX+",
    image: "/images/car-sedona-2019.jpeg",
    images: [
      "/images/car-sedona-2019.jpeg",
      "/images/car-sedona-2019-1.jpeg",
      "/images/car-sedona-2019-2.jpeg",
      "/images/car-sedona-2019-3.jpeg",
      "/images/car-sedona-2019-4.jpeg",
      "/images/car-sedona-2019-5.jpeg",
      "/images/car-sedona-2019-6.jpeg",
    ],
    price: 14999,
    weeklyPayment: 88,
    bodyStyle: "Minivan",
    transmission: "6 Speed Automatic",
    stockNumber: "S17-135",
    isGoodPrice: false,
    km: 67800,
    vin: "KNDMB5C15K1234567",
    engine: "6 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "White",
    drivetrain: "FWD",
    passengers: 7,
    cylinders: 6,
    condition: "Used",
  },
  {
    id: 4,
    year: 2018,
    make: "Toyota",
    model: "Corolla",
    trim: "LE",
    image: "/images/car-corolla-2018.jpeg",
    images: [
      "/images/car-corolla-2018.jpeg",
      "/images/car-corolla-2018-1.jpeg",
      "/images/car-corolla-2018-2.jpeg",
      "/images/car-corolla-2018-3.jpeg",
      "/images/car-corolla-2018-4.jpeg",
      "/images/car-corolla-2018-5.jpeg",
      "/images/car-corolla-2018-6.jpeg",
    ],
    price: 18500,
    weeklyPayment: 179,
    bodyStyle: "Sedan",
    transmission: "6 Speed Automatic",
    stockNumber: "WB23-040",
    isGoodPrice: true,
    km: 38900,
    vin: "2T1BURHE8JC123456",
    engine: "4 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "Grey",
    drivetrain: "FWD",
    passengers: 5,
    cylinders: 4,
    condition: "Used",
  },
  {
    id: 5,
    year: 2021,
    make: "Hyundai",
    model: "Elantra",
    trim: "Preferred",
    image: "/images/car-elantara-2021.jpeg",
    images: [
      "/images/car-elantara-2021.jpeg",
      "/images/car-elantara-2021-2.jpeg",
      "/images/car-elantara-2021-3.jpeg",
      "/images/car-elantara-2021-4.jpeg",
      "/images/car-elantara-2021-5.jpeg",
    ],
    price: 19500,
    weeklyPayment: 166,
    bodyStyle: "Sedan",
    transmission: "CVT Automatic",
    stockNumber: "HY21-204",
    isGoodPrice: true,
    km: 95000,
    vin: "KMHLM4AG5MU123456",
    engine: "4 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "White",
    drivetrain: "FWD",
    passengers: 5,
    cylinders: 4,
    condition: "Used",
  },
  {
    id: 6,
    year: 2021,
    make: "Hyundai",
    model: "Sonata",
    trim: "Preferred",
    image: "/images/car-sonata-2021.jpeg",
    images: [
      "/images/car-sonata-2021.jpeg",
      "/images/car-sonata-2021-1.jpeg",
      "/images/car-sonata-2021-2.jpeg",
      "/images/car-sonata-2021-3.jpeg",
      "/images/car-sonata-2021-4.jpeg",
    ],
    price: 19500,
    weeklyPayment: 83,
    bodyStyle: "Sedan",
    transmission: "Automatic",
    stockNumber: "HY21-206",
    isGoodPrice: true,
    km: 62000,
    vin: "5NPEH4J26MH123456",
    engine: "4 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "White",
    drivetrain: "FWD",
    passengers: 5,
    cylinders: 4,
    condition: "Used",
  },
  {
    id: 7,
    year: 2019,
    make: "Volkswagen",
    model: "Jetta",
    trim: "Highline",
    image: "/images/car-jetta-2019.jpeg",
    images: [
      "/images/car-jetta-2019.jpeg",
      "/images/car-jetta-2019-1.jpeg",
      "/images/car-jetta-2019-2.jpeg",
      "/images/car-jetta-2019-3.jpeg",
      "/images/car-jetta-2019-4.jpeg",
      "/images/car-jetta-2019-5.jpeg",
    ],
    price: 17999,
    weeklyPayment: 83,
    bodyStyle: "Sedan",
    transmission: "Automatic",
    stockNumber: "VW19-207",
    isGoodPrice: true,
    km: 70000,
    vin: "3VWG57BU1KM123456",
    engine: "4 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "White",
    drivetrain: "FWD",
    passengers: 5,
    cylinders: 4,
    condition: "Used",
  },
  {
    id: 8,
    year: 2025,
    make: "Hyundai",
    model: "Elantra",
    trim: "Preferred",
    image: "/images/car-elantra-2025.jpeg",
    images: [
      "/images/car-elantra-2025.jpeg",
      "/images/car-elantra-2025-1.jpeg",
      "/images/car-elantra-2025-2.jpeg",
      "/images/car-elantra-2025-3.jpeg",
      "/images/car-elantra-2025-4.jpeg",
      "/images/car-elantra-2025-5.jpeg",
      "/images/car-elantra-2025-6.jpeg",
      "/images/car-elantra-2025-7.jpeg",
    ],
    price: 25500,
    weeklyPayment: 99.5,
    bodyStyle: "Sedan",
    transmission: "Automatic",
    stockNumber: "HY25-208",
    isGoodPrice: true,
    km: 36000,
    vin: "KMHLM4DGXSU123456",
    engine: "4 Cylinder Engine",
    fuelType: "Gas",
    exteriorColor: "Grey",
    drivetrain: "FWD",
    passengers: 5,
    cylinders: 4,
    condition: "Used",
  },
];

export type CarItem = (typeof carsData)[number];

export type InventoryCarItem = {
  id: string;
  year: number;
  make: string;
  model: string;
  trim: string;
  image: string;
  images: string[];
  price: number | null;
  weeklyPayment: number | null;
  installmentAmount: number | null;
  installmentPercentage: string;
  installmentType: string;
  installmentDuration: number | null;
  bodyStyle: string;
  transmission: string;
  stockNumber: string;
  tagLabel: string;
  isGoodPrice: boolean;
  km: number | null;
  vin: string;
  engine: string;
  fuelType: string;
  exteriorColor: string;
  drivetrain: string;
  passengers: string;
  cylinders: string;
  condition: string;
  carfxUrl: string;
  status: string;
  isSold: boolean;
};

export type VehicleFeatureItem = {
  id: string;
  name: string;
  type: string;
};

export type VehicleDetailsItem = {
  id: string;
  year: number;
  make: string;
  model: string;
  trim: string;
  image: string;
  images: string[];
  price: number | null;
  weeklyPayment: number | null;
  installmentAmount: number | null;
  installmentPercentage: string;
  installmentType: string;
  installmentDuration: number | null;
  bodyStyle: string;
  transmission: string;
  stockNumber: string;
  tagLabel: string;
  isGoodPrice: boolean;
  km: number | null;
  vin: string;
  engine: string;
  fuelType: string;
  exteriorColor: string;
  drivetrain: string;
  passengers: string;
  cylinders: string;
  doors: string;
  insurance: string;
  condition: string;
  description: string;
  mileage: string;
  features: VehicleFeatureItem[];
  carfxUrl: string;
  status: string;
  isSold: boolean;
};

type InventoryApiImage = {
  image_id?: number | string | null;
  Image_URL?: string | null;
  default_image?: string | null;
};

type InventoryApiFeature = {
  Feature_id?: number | string | null;
  Feature_Name?: string | null;
  Feature_Type?: string | null;
};

type InventoryApiCar = {
  item_id: number | string;
  Reg_Number?: string | null;
  Make_year?: number | string | null;
  Reg_Year?: number | string | null;
  KM_driven?: number | string | null;
  mileage?: string | null;
  description?: string | null;
  Price?: number | string | null;
  inst_amount?: number | string | null;
  inst_percentage?: number | string | null;
  inst_type?: string | null;
  inst_duration?: number | string | null;
  Color?: string | null;
  Owner?: string | null;
  Status?: string | null;
  Spare_key?: string | null;
  Insurance?: string | null;
  Brand_id?: number | string | null;
  Brand_Name?: string | null;
  Model_Name?: string | null;
  Category?: string | null;
  Transmission_type?: string | null;
  Fuel_type?: string | null;
  Drive_Train?: string | null;
  Doors?: string | null;
  No_of_Cylinders?: string | null;
  Seating_Capacity?: string | null;
  Condition?: string | null;
  tag?: string | null;
  carfx_url?: string | null;
  item_Images?: InventoryApiImage[] | null;
  features?: InventoryApiFeature[] | null;
};

type InventoryApiResponse = {
  success: boolean;
  message: string;
  data: InventoryApiCar[];
  pagination?: {
    page?: number;
    limit?: number;
    total?: number;
    total_pages?: number;
  };
};

export type InventoryPagination = {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
};

export type FetchInventoryCarsParams = {
  page?: number;
  limit?: number;
  keyword?: string;
  conditions?: string[];
  brands?: string[];
  models?: string[];
  bodyStyles?: string[];
  transmissions?: string[];
  colors?: string[];
  fuelTypes?: string[];
  drivetrains?: string[];
  cylinders?: string[];
  passengers?: string[];
  priceMin?: number;
  priceMax?: number;
  yearMin?: number;
  yearMax?: number;
  kmMin?: number;
  kmMax?: number;
  ordBy?: number;
};

export type FetchInventoryCarsResult = {
  cars: InventoryCarItem[];
  pagination: InventoryPagination;
};

export type InventoryFilterOption = {
  value: string;
  label: string;
  brandId?: string;
};

export type InventoryFilters = {
  conditions: InventoryFilterOption[];
  makes: InventoryFilterOption[];
  models: InventoryFilterOption[];
  bodyStyles: InventoryFilterOption[];
  transmissions: InventoryFilterOption[];
  colors: InventoryFilterOption[];
  fuelTypes: InventoryFilterOption[];
  drivetrains: InventoryFilterOption[];
  cylindersOptions: InventoryFilterOption[];
  passengersOptions: InventoryFilterOption[];
};

type InventoryFilterApiOption = {
  value?: number | string | null;
  label?: string | null;
  brand_id?: number | string | null;
};

type InventoryFilterApiResponse = {
  success: boolean;
  message: string;
  data?: {
    CYLINDER?: InventoryFilterApiOption[];
    CONDITION_TYPE?: InventoryFilterApiOption[];
    SEAT_CAPACITY?: InventoryFilterApiOption[];
    DRIVE_TYPE?: InventoryFilterApiOption[];
    FUEL_TYPE?: InventoryFilterApiOption[];
    CAR_TYPE?: InventoryFilterApiOption[];
    COLOR?: InventoryFilterApiOption[];
    TRANS_TYPE?: InventoryFilterApiOption[];
    brand_name?: InventoryFilterApiOption[];
    model_name?: InventoryFilterApiOption[];
  };
};

const API_BASE_URL = "https://bbadmin.squaretrigger.com";
const API_IMAGE_BASE_URL = "https://bbadmin.squaretrigger.com/api";
const INVENTORY_API_URL = `${API_BASE_URL}/api/filter/car`;
const FILTER_API_URL = `${API_BASE_URL}/api/filter`;

export const EMPTY_INVENTORY_FILTERS: InventoryFilters = {
  conditions: [],
  makes: [],
  models: [],
  bodyStyles: [],
  transmissions: [],
  colors: [],
  fuelTypes: [],
  drivetrains: [],
  cylindersOptions: [],
  passengersOptions: [],
};

const toText = (value: unknown): string =>
  typeof value === "string" ? value.trim() : "";

const toNullableNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toId = (value: unknown): string =>
  value === null || value === undefined ? "" : String(value).trim();

const normalizeExternalUrl = (value: unknown): string => {
  const url = toText(value);

  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;

  return `https://${url}`;
};

const isSoldStatus = (value: unknown): boolean => {
  const normalized = toText(value).toLowerCase();
  return normalized === "sold" || normalized === "sold out";
};
const sanitizeList = (values?: string[]): string[] =>
  Array.from(
    new Set((values ?? []).map((value) => value.trim()).filter(Boolean)),
  );

const buildAbsoluteImageUrl = (imagePath: string): string => {
  const trimmed = imagePath.trim();

  if (!trimmed) return "";

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `${API_IMAGE_BASE_URL}${trimmed.startsWith("/") ? trimmed : `/${trimmed}`}`;
};

const getSortedInventoryImageUrls = (
  images?: InventoryApiImage[] | null,
): string[] => {
  return [...(images ?? [])]
    .sort((a, b) => {
      const aDefault = a.default_image === "Y" ? 0 : 1;
      const bDefault = b.default_image === "Y" ? 0 : 1;
      return aDefault - bDefault;
    })
    .map((img) => buildAbsoluteImageUrl(toText(img.Image_URL)))
    .filter(Boolean);
};

const mapInventoryApiFeatures = (
  features?: InventoryApiFeature[] | null,
): VehicleFeatureItem[] => {
  return (features ?? []).map((feature) => ({
    id: toId(feature.Feature_id),
    name: toText(feature.Feature_Name),
    type: toText(feature.Feature_Type),
  }));
};

const appendArrayParams = (
  params: URLSearchParams,
  key: string,
  values?: string[],
) => {
  sanitizeList(values).forEach((value) => {
    params.append(key, value);
  });
};

const setCsvParam = (
  params: URLSearchParams,
  key: string,
  values?: string[],
) => {
  const cleaned = sanitizeList(values);
  if (cleaned.length > 0) {
    params.set(key, cleaned.join(","));
  }
};

const setNumberParam = (
  params: URLSearchParams,
  key: string,
  value?: number,
) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    params.set(key, String(value));
  }
};

const mapInventoryApiToCar = (item: InventoryApiCar): InventoryCarItem => {
  const gallery = getSortedInventoryImageUrls(item.item_Images);
  const tagLabel = toText(item.tag);
  const status = toText(item.Status);
  const isSold = isSoldStatus(item.Status);

  return {
    id: toId(item.item_id),
    year: Number(item.Make_year) || 0,
    make: toText(item.Brand_Name),
    model: toText(item.Model_Name),
    trim: "",
    image: gallery[0] ?? "",
    images: gallery,
    price: toNullableNumber(item.Price),
    weeklyPayment: toNullableNumber(item.inst_amount),
    installmentAmount: toNullableNumber(item.inst_amount),
    installmentPercentage: toText(item.inst_percentage),
    installmentType: toText(item.inst_type),
    installmentDuration: toNullableNumber(item.inst_duration),
    bodyStyle: toText(item.Category),
    transmission: toText(item.Transmission_type),
    stockNumber: toText(item.Reg_Number),
    tagLabel,
    isGoodPrice: Boolean(tagLabel),
    km: toNullableNumber(item.KM_driven),
    vin: "",
    engine: "",
    fuelType: toText(item.Fuel_type),
    exteriorColor: toText(item.Color),
    drivetrain: toText(item.Drive_Train),
    passengers: toText(item.Seating_Capacity),
    cylinders: toText(item.No_of_Cylinders),
    condition: toText(item.Condition),
    carfxUrl: normalizeExternalUrl(item.carfx_url),
    status,
    isSold,
  };
};

const buildInventoryCarsUrl = (
  filters: FetchInventoryCarsParams = {},
): string => {
  const url = new URL(INVENTORY_API_URL);
  const params = url.searchParams;

  params.set("page", String(filters.page ?? 1));
  params.set("limit", String(filters.limit ?? 15));
  params.set("keyword", (filters.keyword ?? "").trim());

  appendArrayParams(params, "condition[]", filters.conditions);
  appendArrayParams(params, "brand[]", filters.brands);
  appendArrayParams(params, "model[]", filters.models);
  appendArrayParams(params, "body_style[]", filters.bodyStyles);
  appendArrayParams(params, "transmission[]", filters.transmissions);

  setCsvParam(params, "color", filters.colors);
  setCsvParam(params, "fuel_type", filters.fuelTypes);
  setCsvParam(params, "drive_train", filters.drivetrains);
  setCsvParam(params, "cylinders", filters.cylinders);
  setCsvParam(params, "passengers", filters.passengers);

  setNumberParam(params, "price_min", filters.priceMin);
  setNumberParam(params, "price_max", filters.priceMax);
  setNumberParam(params, "make_year_min", filters.yearMin);
  setNumberParam(params, "make_year_max", filters.yearMax);
  setNumberParam(params, "km_driven_min", filters.kmMin);
  setNumberParam(params, "km_driven_max", filters.kmMax);

  params.set("ord_by", String(filters.ordBy ?? 2));

  return url.toString();
};

async function fetchInventoryCarsPage(
  filters: FetchInventoryCarsParams = {},
): Promise<InventoryApiResponse> {
  const response = await fetch(buildInventoryCarsUrl(filters));

  if (!response.ok) {
    throw new Error(`Inventory API failed with status ${response.status}`);
  }

  return (await response.json()) as InventoryApiResponse;
}

export async function fetchInventoryCars(
  filters: FetchInventoryCarsParams = {},
): Promise<FetchInventoryCarsResult> {
  const response = await fetch(buildInventoryCarsUrl(filters));

  if (!response.ok) {
    throw new Error(`Inventory API failed with status ${response.status}`);
  }

  const payload = (await response.json()) as InventoryApiResponse;

  if (!payload.success || !Array.isArray(payload.data)) {
    return {
      cars: [],
      pagination: {
        page: filters.page ?? 1,
        limit: filters.limit ?? 10,
        total: 0,
        totalPages: 1,
      },
    };
  }

  return {
    cars: payload.data.map(mapInventoryApiToCar),
    pagination: {
      page: Number(payload.pagination?.page) || filters.page || 1,
      limit: Number(payload.pagination?.limit) || filters.limit || 10,
      total: Number(payload.pagination?.total) || payload.data.length,
      totalPages: Number(payload.pagination?.total_pages) || 1,
    },
  };
}

const mapInventoryApiToVehicleDetails = (
  item: InventoryApiCar,
): VehicleDetailsItem => {
  const gallery = getSortedInventoryImageUrls(item.item_Images);
  const tagLabel = toText(item.tag);
  const status = toText(item.Status);
  const isSold = isSoldStatus(item.Status);

  return {
    id: toId(item.item_id),
    year: Number(item.Make_year) || 0,
    make: toText(item.Brand_Name),
    model: toText(item.Model_Name),
    trim: "",
    image: gallery[0] ?? "",
    images: gallery,
    price: toNullableNumber(item.Price),
    weeklyPayment: toNullableNumber(item.inst_amount),
    installmentAmount: toNullableNumber(item.inst_amount),
    installmentPercentage: toText(item.inst_percentage),
    installmentType: toText(item.inst_type),
    installmentDuration: toNullableNumber(item.inst_duration),
    bodyStyle: toText(item.Category),
    transmission: toText(item.Transmission_type),
    stockNumber: toText(item.Reg_Number),
    tagLabel,
    isGoodPrice: Boolean(tagLabel),
    km: toNullableNumber(item.KM_driven),
    vin: "",
    engine: toText(item.No_of_Cylinders),
    fuelType: toText(item.Fuel_type),
    exteriorColor: toText(item.Color),
    drivetrain: toText(item.Drive_Train),
    passengers: toText(item.Seating_Capacity),
    cylinders: toText(item.No_of_Cylinders),
    doors: toText(item.Doors),
    insurance:
      toText(item.Insurance) === "Y"
        ? "Yes"
        : toText(item.Insurance) === "N"
          ? "No"
          : toText(item.Insurance),
    condition: toText(item.Condition),
    description: toText(item.description),
    mileage: toText(item.mileage),
    features: mapInventoryApiFeatures(item.features),
    carfxUrl: normalizeExternalUrl(item.carfx_url),
    status,
    isSold,
  };
};

export async function fetchAllInventoryCars(
  filters: Omit<FetchInventoryCarsParams, "page" | "limit"> = {},
): Promise<InventoryCarItem[]> {
  let page = 1;
  let totalPages = 1;
  const allCars: InventoryCarItem[] = [];

  do {
    const payload = await fetchInventoryCarsPage({
      ...filters,
      page,
      limit: 100,
    });

    if (payload.success && Array.isArray(payload.data)) {
      allCars.push(...payload.data.map(mapInventoryApiToCar));
    }

    totalPages = Number(payload.pagination?.total_pages) || 1;
    page += 1;
  } while (page <= totalPages);

  return Array.from(new Map(allCars.map((car) => [car.id, car])).values());
}

export async function fetchVehicleDetailsById(
  vehicleId: string,
): Promise<VehicleDetailsItem | null> {
  const normalizedVehicleId = toId(vehicleId);

  if (!normalizedVehicleId) {
    return null;
  }

  let page = 1;
  let totalPages = 1;

  do {
    const payload = await fetchInventoryCarsPage({
      page,
      limit: 100,
      ordBy: 2,
    });

    if (payload.success && Array.isArray(payload.data)) {
      const matched = payload.data.find(
        (item) => toId(item.item_id) === normalizedVehicleId,
      );

      if (matched) {
        return mapInventoryApiToVehicleDetails(matched);
      }
    }

    totalPages = Number(payload.pagination?.total_pages) || 1;
    page += 1;
  } while (page <= totalPages);

  return null;
}

const mapValueLabelOptions = (
  options?: InventoryFilterApiOption[],
): InventoryFilterOption[] => {
  const optionMap = new Map<string, InventoryFilterOption>();

  (options ?? []).forEach((option) => {
    const value =
      option.value === null || option.value === undefined
        ? ""
        : String(option.value).trim();
    const label = toText(option.label);
    const brandId =
      option.brand_id === null || option.brand_id === undefined
        ? undefined
        : String(option.brand_id).trim() || undefined;

    if (!value || !label) return;

    optionMap.set(value, { value, label, brandId });
  });

  return Array.from(optionMap.values()).sort((a, b) =>
    a.label.localeCompare(b.label),
  );
};

export async function fetchInventoryFilters(): Promise<InventoryFilters> {
  const response = await fetch(FILTER_API_URL);

  if (!response.ok) {
    throw new Error(`Filter API failed with status ${response.status}`);
  }

  const payload = (await response.json()) as InventoryFilterApiResponse;

  if (!payload.success || !payload.data) {
    return EMPTY_INVENTORY_FILTERS;
  }

  return {
    conditions: mapValueLabelOptions(payload.data.CONDITION_TYPE),
    makes: mapValueLabelOptions(payload.data.brand_name),
    models: mapValueLabelOptions(payload.data.model_name),
    bodyStyles: mapValueLabelOptions(payload.data.CAR_TYPE),
    transmissions: mapValueLabelOptions(payload.data.TRANS_TYPE),
    colors: mapValueLabelOptions(payload.data.COLOR),
    fuelTypes: mapValueLabelOptions(payload.data.FUEL_TYPE),
    drivetrains: mapValueLabelOptions(payload.data.DRIVE_TYPE),
    cylindersOptions: mapValueLabelOptions(payload.data.CYLINDER),
    passengersOptions: mapValueLabelOptions(payload.data.SEAT_CAPACITY),
  };
}

export type CompareCarItem = {
  id: string;
  title: string;
  image: string;
  price: number | null;
  weeklyPayment: number | null;
  tagLabel: string;
  isGoodPrice: boolean;
  condition: string;
  km: number | null;
  bodyStyle: string;
  engine: string;
  transmission: string;
  fuelType: string;
  exteriorColor: string;
  drivetrain: string;
  passengers: string;
  cylinders: string;
  stockNumber: string;
  vin: string;
};

export type CompareRowData = {
  key: string;
  label: string;
  values: Array<string | number | null>;
  betterItemId: string | null;
};

export type CompareCarsResult = {
  items: CompareCarItem[];
  comparison: CompareRowData[];
};

type CompareApiItem = {
  item_id?: number | string | null;
  title?: string | null;
  primary_image?: string | null;
  price?: number | string | null;
  weekly_price?: number | string | null;
  price_tag?: string | null;
  condition?: string | null;
  kilometres?: number | string | null;
  body_style?: string | null;
  engine?: string | null;
  transmission?: string | null;
  fuel_type?: string | null;
  exterior_colour?: string | null;
  drive_train?: string | null;
  passengers?: number | string | null;
  cylinders?: number | string | null;
};

type CompareApiComparisonRow = {
  key?: string | null;
  label?: string | null;
  values?: Array<string | number | null> | null;
  better_item_id?: number | string | null;
};

type CompareApiResponse = {
  success: boolean;
  message: string;
  data?: {
    items?: CompareApiItem[];
    comparison?: CompareApiComparisonRow[];
  };
};

const COMPARE_API_URL = `${API_BASE_URL}/api/filter/comparecar`;

const normalizeCompareId = (value: unknown): string => toId(value);

const normalizeBetterItemId = (value: unknown): string | null => {
  const normalized = toId(value);
  return normalized || null;
};

const mapCompareApiItem = (item: CompareApiItem): CompareCarItem => {
  const tagLabel = toText(item.price_tag);

  return {
    id: toId(item.item_id),
    title: toText(item.title),
    image: buildAbsoluteImageUrl(toText(item.primary_image)),
    price: toNullableNumber(item.price),
    weeklyPayment: toNullableNumber(item.weekly_price),
    tagLabel,
    isGoodPrice: Boolean(tagLabel),
    condition: toText(item.condition),
    km: toNullableNumber(item.kilometres),
    bodyStyle: toText(item.body_style),
    engine: toText(item.engine),
    transmission: toText(item.transmission),
    fuelType: toText(item.fuel_type),
    exteriorColor: toText(item.exterior_colour),
    drivetrain: toText(item.drive_train),
    passengers:
      item.passengers === null || item.passengers === undefined
        ? ""
        : String(item.passengers),
    cylinders:
      item.cylinders === null || item.cylinders === undefined
        ? ""
        : String(item.cylinders),
    stockNumber: "",
    vin: "",
  };
};

export async function fetchCompareCars(
  itemIds: string[],
): Promise<CompareCarsResult> {
  const ids = Array.from(
    new Set(itemIds.map((id) => normalizeCompareId(id)).filter(Boolean)),
  ).slice(0, 2);

  if (ids.length < 2) {
    return { items: [], comparison: [] };
  }

  const url = new URL(COMPARE_API_URL);
  ids.forEach((id) => url.searchParams.append("item_ids[]", id));

  const response = await fetch(url.toString());

  if (!response.ok) {
    throw new Error(`Compare API failed with status ${response.status}`);
  }

  const payload = (await response.json()) as CompareApiResponse;

  if (!payload.success || !payload.data) {
    return { items: [], comparison: [] };
  }

  return {
    items: (payload.data.items ?? []).map(mapCompareApiItem),
    comparison: (payload.data.comparison ?? []).map((row) => ({
      key: toText(row.key),
      label: toText(row.label),
      values: Array.isArray(row.values) ? row.values : [],
      betterItemId: normalizeBetterItemId(row.better_item_id),
    })),
  };
}
